export function ReliabilityBar({ pct }: { pct: number }) {
  const color = pct >= 78 ? 'var(--signal)' : pct >= 70 ? 'var(--warn)' : 'var(--overdue)'
  return (
    <div className="flex items-center gap-3 min-w-[140px]">
      <div className="flex-1 h-2 rounded-full bg-surface-2 overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="font-mono text-sm tabular-nums" style={{ color }}>
        {pct}%
      </span>
    </div>
  )
}
